import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const heading = Loadable(() => import('../../containers/web/heading'));
export default MapTo('vcg/components/soe-home/react/creditcheck/heading')(heading);
